import * as React from 'react';

import moment from 'moment';

import { useIntl } from 'bundles/page/lib/useIntl';
import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';

import _t from 'i18n!nls/xdp';

type Props = {
  totalDuration: string;
};

export const KeyInformationCourseDurationAndSchedule = ({ totalDuration }: Props) => {
  const intl = useIntl();
  let totalHours = moment.duration(totalDuration).asHours();

  totalHours = totalHours > 1 ? Math.floor(totalHours) : 1;

  return (
    <KeyInformationDetailsItem
      title={_t('Flexible schedule')}
      subtitle={
        <>
          <div>
            {intl.formatMessage(_t('Approx. {totalHours} {totalHours, plural, =1 {hour} other {hours}}'), {
              totalHours,
            })}
          </div>
          <div>{_t('Learn at your own pace')}</div>
        </>
      }
    />
  );
};

export default KeyInformationCourseDurationAndSchedule;
